<app-page-body class="flex-fill">
  <header class="px-3 py-4 rounded-top-3 text-center text-uppercase">
    <h1 class="mb-0 fs-2">
      <mat-icon *ngIf="!!icon"
                class="mr-3 mb-1 align-middle text-primary"
                fontSet="design">{{icon}}</mat-icon>
      {{title}}{{titleSuffix}}
    </h1>
  </header>
  <ng-content></ng-content>
</app-page-body>